import { Campaign } from '@dev/ee-api/ee-api-models';
import { ApplicationState } from '..';
import * as Types from './types';
import { CampaignsState } from './types';

const { ActionTypes } = Types;

export const GetCampaigns = (campaignsPayload: Types.GetCampaignsPayload): Types.GetCampaingsAction => ({
    type: ActionTypes.GET_CAMPAIGNS,
    payload: campaignsPayload,
});

export const UpdateCampaignsStore = (campaignsList: Campaign[]): Types.UpdateCampaignsStoreAction => ({
    type: ActionTypes.UPDATE_CAMPAIGNS_STORE,
    payload: {
        campaignsList,
    },
});

export const CampaignsError = (): Types.CampaignsErrorAction => ({
    type: ActionTypes.CAMPAIGNS_ERROR,
});

export const getCampaignsStore = (state: ApplicationState): CampaignsState => state.campaigns;
